import React from 'react'

export function YoutubeIcon(props) {


    return (
        <>
            <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M22.806 1.26818C23.5252 2.0016 23.76 3.66708 23.76 3.66708C23.76 3.66708 24 5.62336 24 7.57889V9.4128C24 11.3691 23.76 13.3246 23.76 13.3246C23.76 13.3246 23.5252 14.9901 22.806 15.7235C21.9837 16.5911 21.0719 16.6808 20.5565 16.7314C20.4998 16.737 20.4479 16.7421 20.4015 16.7477C17.043 16.9924 12 17 12 17C12 17 5.76 16.9426 3.84 16.7568C3.74903 16.7397 3.63876 16.7264 3.51388 16.7113C2.9057 16.6378 1.95113 16.5225 1.19325 15.7235C0.474 14.9901 0.24 13.3246 0.24 13.3246C0.24 13.3246 0 11.3691 0 9.4128V7.57889C0 5.62336 0.24 3.66708 0.24 3.66708C0.24 3.66708 0.474 2.0016 1.19325 1.26818C2.0174 0.399349 2.93006 0.310675 3.44548 0.260597C3.50136 0.255167 3.55258 0.250191 3.5985 0.244724C6.957 0 11.9948 0 11.9948 0H12.0052C12.0052 0 17.043 0 20.4015 0.244724C20.4474 0.250199 20.4987 0.255182 20.5546 0.260621C21.0696 0.310704 21.9827 0.39949 22.806 1.26818ZM9.52125 4.84387L9.522 11.635L16.0057 8.25112L9.52125 4.84387Z" fill="#0A142F" />
            </svg>

        </>
    )
}
